// Tour slides
import slide1 from '../../../../../assets/onboarding_slide_1.png';
import slide2 from '../../../../../assets/onboarding_slide_2.png';
import slide3 from '../../../../../assets/onboarding_slide_3.jpg';
import slide4 from '../../../../../assets/onboarding_slide_4.png';
import slide5 from '../../../../../assets/onboarding_slide_5.jpg';
import {getAssetPath} from 'epic-diesel-common/src/utils/DieselUtils';

export const TOUR_STEPS = [
    [
        'epic.affiliate.fortnite_games.tour.slide_1.title',
        'epic.affiliate.fortnite_games.tour.slide_1.description',
        getAssetPath(slide1)
    ],
    [
        'epic.affiliate.fortnite_games.tour.slide_2.title',
        'epic.affiliate.fortnite_games.tour.slide_2.description',
        getAssetPath(slide2)
    ],
    [
        'epic.affiliate.fortnite_games.tour.slide_3.title',
        'epic.affiliate.fortnite_games.tour.slide_3.description',
        getAssetPath(slide3)
    ],
    [
        'epic.affiliate.fortnite_games.tour.slide_4.title',
        'epic.affiliate.fortnite_games.tour.slide_4.description',
        getAssetPath(slide4)
    ],
    [
        'epic.affiliate.fortnite_games.tour.slide_5.title',
        'epic.affiliate.fortnite_games.tour.slide_5.description',
        getAssetPath(slide5)
    ]
];
